module.exports = fox._r("components/valentines-gifts-popup/fonts/arvo-bold-webfont.woff2", __webpack_public_path__ + "_/_/_/root/components/valentines-gifts-popup/fonts/3p73Hh6.woff2");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/fonts/arvo-bold-webfont.woff2
// module id = 724
// module chunks = 4